
import { Box } from "@mui/material";

import type { WidgetProps } from "./types";

export function CalendlyEmbed({ widget }: WidgetProps<"calendly_embed">) {
    const height = widget.props.height ?? 700;
    return (
        <Box
            component="iframe"
            src={widget.props.url}
            sx={{
                width: "100%",
                height,
                border: 0,
                borderRadius: "10px",
                bgcolor: "background.paper",
            }}
        />
    );
}
